import { Box, Divider, Grid } from '@mui/material';
import CaseInfoItem from 'components/case/CaseInfoItem/CaseInfoItem';
import ICDItem from 'components/case/ICDItem/ICDItem';
import CustomText from 'components/common/CustomText/CustomText';
import React, { useMemo } from 'react'
import { colors } from 'styles/colors';
import useGlobalStyles from 'styles/globalStyles';
import { ICD } from 'types/types';

interface Props {
  data: any;
}

export default function ICDDetails({ data }: Props) {
  const globalStyles = useGlobalStyles();


  return (
    <Box className={globalStyles.sectionContainer}>
      <Box className={globalStyles.sectionHeader}>
        <CustomText
          text="ICD-9/10"
          color={colors.primary}
          fontWeight={600}
        />
      </Box>

      <Divider />

      <Grid container p={3} spacing={1.5}>
        {data.procedure_icd.map((item: any, index: number) => (
          <Grid
            size={{ xs: 12, md: 6 }}
            key={`${item.icd_lookup.code}-${index}`}>
            <ICDItem item={item} />
          </Grid>
        ))}

        {data.icds?.length == 0 && (
          <Box>
            <CustomText text={'N/A'} />
          </Box>
        )}
      </Grid>

    </Box>
  )
}
